export const MODAL_LIST_ADD = 'MODAL_LIST_ADD';
export const MODAL_LIST_REMOVE = 'MODAL_LIST_REMOVE';
export const MODAL_LIST_CLEAR = 'MODAL_LIST_CLEAR';
